<template>
    <a-config-provider :locale="arcoLocale">
    <div class="main-box">
        <p class="title">{{ $t('assets.fund_flow') }}</p>
        <a-tabs default-active-key="1" @change="tabChange">
            <a-tab-pane :title="$t('assets.fund_account')" key="1">
                <div class="select-group">
                    <div class="select-label">
                        <p>{{ $t('assets.time') }}</p>
                        <a-range-picker
                            :render-to-body="false"
                            popup-container="body"
                            :defaultValue="['2023-01-01 00:00:00']"
                            v-model="timeValue"
                            class="time-button"
                            :allow-clear="false"
                            :placeholder="[$t('common.start_date'), $t('common.end_date')]"
                            @change="onChange"
                            @select="onSelect"
                        />
                    </div>
                    <div class="select-label">
                        <p>{{ $t('assets.flow_type') }}</p>
                        <a-dropdown @select="handleSelect">
                            <a-button class="label-button">
                                {{ selectedType }}
                                <icon-caret-down/>
                            </a-button>
                            <template #content>
                                <a-doption v-for="(item,index) in genre" :key="index" :value="item">{{ $t(item) }}</a-doption>
                            </template>
                        </a-dropdown>
                    </div>
                    <div class="select-label">
                        <p>{{ $t('assets.coin') }}</p>
                        <a-select v-model="selectedCurrency" :placeholder="$t('assets.all_coins')">
                            <a-option v-for="(item,index) in coinList" :key="index" :value="item">{{ item === 'assets.all_coins' ? $t(item) : item }}</a-option>
                        </a-select>
                    </div>
                    <div class="select-label">
                        <p>{{ $t('common.status') }}</p>
                        <a-dropdown @select="handleSelect">
                            <a-button class="label-button">
                                {{ selectedStatus }}
                                <icon-caret-down/>
                            </a-button>
                            <template #content>
                                <a-doption v-for="(item,index) in stateOption" :key="index" :value="item">{{ $t(item) }}</a-doption>
                            </template>
                        </a-dropdown>
                    </div>
                    <div class="select-label">
                        <p style="visibility: hidden;">&nbsp;</p>
                        <a-button class="label-button" @click="reset">
                            {{ $t('assets.reset') }}
                        </a-button>
                    </div>
                </div>

                <div class="list" type="zj">
                    <div class="top">
                        <div class="cell">
                            <div class="item">
                                <span>{{ $t('assets.time') }}</span>
                            </div>
                            <div class="item">
                                <span>{{ $t('assets.coin') }}</span>
                            </div>
                            <div class="item">
                                <span>{{ $t('assets.quantity') }}</span>
                            </div>
<!--                            <div class="item">-->
<!--                                <span>确认次数</span>-->
<!--                            </div>-->
                            <div class="item">
                                <span>{{ $t('assets.type') }}</span>
                            </div>
<!--                            <div class="item">-->
<!--                                <span>{{ $t('common.operation') }}</span>-->
<!--                            </div>-->
                        </div>
                        <div class="cell" v-for="(item,index) in logList" :key="'b'+item.id">
                            <div class="item">
                                <span>{{item.created_at}}</span>
                            </div>
                            <div class="item coin">
                                <img :src="item.currency.icon" alt="">
                                <span>{{item.currency.symbol}}</span>
                            </div>
                            <div class="item">
                                <span>{{formatNumber(item.amount)}}</span>
                            </div>
                            <div class="item">
                                <span>{{types[item.type] || item.type}}</span>
                            </div>
<!--                            <div class="item">-->
<!--                                <span @click="openModalDetail(item)" class="pointer">{{ $t('common.details') }}</span>-->
<!--                            </div>-->
                        </div>
                    </div>
                    <div class="btm">
                        <div class="pagination-container">
                            <span class="total-text">{{ paginationText }}</span>
                            <a-pagination 
                                @change="paginate" 
                                :total="total" 
                                :page-size="size" 
                                :show-total="false"
                                show-jumper
                            />
                        </div>
                    </div>
                </div>
            </a-tab-pane>
            <a-tab-pane :title="$t('assets.spot_account')" key="2">
                <div class="select-group">
                    <div class="select-label">
                        <p>{{ $t('assets.time') }}</p>
                        <a-range-picker
                            :render-to-body="false"
                            popup-container="body"
                            :defaultValue="timeValue"
                            class="time-button"
                            :allow-clear="false"
                            :placeholder="[$t('common.start_date'), $t('common.end_date')]"
                            @change="onChange"
                            @select="onSelect"
                        />
                    </div>
                    <div class="select-label">
                        <p>{{ $t('assets.flow_type') }}</p>
                        <a-dropdown @select="handleSelect">
                            <a-button class="label-button">
                                {{ selectedType }}
                                <icon-caret-down/>
                            </a-button>
                            <template #content>
                                <a-doption v-for="(item,index) in genre" :key="index" :value="item">{{ $t(item) }}</a-doption>
                            </template>
                        </a-dropdown>
                    </div>
                    <div class="select-label">
                        <p>{{ $t('assets.coin') }}</p>
                        <a-dropdown @select="handleSelect">
                            <a-button class="label-button">
                                {{ selectedCurrency }}
                                <icon-caret-down/>
                            </a-button>
                            <template #content>
                                <a-doption v-for="(item,index) in coinList" :key="index" :value="item">{{ item === 'assets.all_coins' ? $t(item) : item }}</a-doption>
                            </template>
                        </a-dropdown>
                    </div>
                    <div class="select-label">
                        <p style="visibility: hidden;">&nbsp;</p>
                        <a-button class="label-button" @click="reset">
                            {{ $t('assets.reset') }}
                        </a-button>
                    </div>
                </div>

                <div class="list" type="xh">
                    <div class="top">
                        <div class="cell">
                            <div class="item">
                                <span>{{ $t('assets.time') }}</span>
                            </div>
                            <div class="item">
                                <span>{{ $t('assets.coin') }}</span>
                            </div>
                            <div class="item">
                                <span>{{ $t('assets.type') }}</span>
                            </div>
                            <div class="item">
                                <span>{{ $t('assets.quantity') }}</span>
                            </div>
                            <div class="item">
                                <span>{{ $t('common.status') }}</span>
                            </div>
                        </div>
                        <div class="cell" v-for="(item,index) in logList" :key="'t'+item.id">
                            <div class="item">
                                <span>{{item.created_at}}</span>
                            </div>
                            <div class="item coin">
                                <img :src="item.currency.icon" alt="">
                                <span>{{item.currency.symbol}}</span>
                            </div>
                            <div class="item">
                                <span>{{types[item.type]}}</span>
                            </div>
                            <div class="item">
                                <span>{{formatNumber(item.amount)}}</span>
                            </div>
                            <div class="item">
                                <span>{{item.amount > 0 ? $t('assets.income') : $t('assets.expense') }}</span>
                            </div>
                        </div>
                    </div>
                    <div class="btm">
                        <div class="pagination-container">
                            <span class="total-text">{{ paginationText }}</span>
                            <a-pagination 
                                @change="paginate" 
                                :total="total" 
                                :page-size="size" 
                                :show-total="false"
                                show-jumper
                            />
                        </div>
                    </div>
                </div>
            </a-tab-pane>
            <a-tab-pane :title="$t('assets.futures_account')" key="3">
                <div class="select-group">
                    <div class="select-label">
                        <p>{{ $t('assets.time') }}</p>
                        <a-range-picker
                            :render-to-body="false"
                            popup-container="body"
                            :defaultValue="timeValue"
                            v-model="timeValue"
                            class="time-button"
                            :allow-clear="false"
                            :placeholder="[$t('common.start_date'), $t('common.end_date')]"
                            @change="onChange"
                            @select="onSelect"
                        />
                    </div>
                    <div class="select-label">
                        <p>{{ $t('assets.flow_type') }}</p>
                        <a-dropdown @select="handleSelect">
                            <a-button class="label-button">
                                {{ selectedType }}
                                <icon-caret-down/>
                            </a-button>
                            <template #content>
                                <a-doption v-for="(item,index) in genre" :key="index" :value="item">{{ $t(item) }}</a-doption>
                            </template>
                        </a-dropdown>
                    </div>
                    <div class="select-label">
                        <p>{{ $t('assets.coin') }}</p>
                        <a-dropdown @select="handleSelect">
                            <a-button class="label-button">
                                {{ selectedCurrency }}
                                <icon-caret-down/>
                            </a-button>
                            <template #content>
                                <a-doption v-for="(item,index) in coinList" :key="index" :value="item">{{ item === 'assets.all_coins' ? $t(item) : item }}</a-doption>
                            </template>
                        </a-dropdown>
                    </div>
                    <div class="select-label">
                        <p style="visibility: hidden;">&nbsp;</p>
                        <a-button class="label-button" @click="reset">
                            {{ $t('assets.reset') }}
                        </a-button>
                    </div>
                </div>

                <div class="list" type="xh">
                    <div class="top">
                        <div class="cell">
                            <div class="item">
                                <span>{{ $t('assets.time') }}</span>
                            </div>
                            <div class="item">
                                <span>{{ $t('assets.type') }}</span>
                            </div>
                            <div class="item">
                                <span>{{ $t('assets.amount') }}</span>
                            </div>
                            <div class="item">
                                <span>{{ $t('common.status') }}</span>
                            </div>
                            <div class="item">
                                <span>{{ $t('assets.coin') }}</span>
                            </div>
                        </div>
                        <div class="cell" v-for="(item,index) in logList" :key="'c'+item.id">
                            <div class="item">
                                <span>{{item.created_at}}</span>
                            </div>
                            <div class="item">
                                <span>{{types[item.type]}}</span>
                            </div>
                            <div class="item">
                                <span>{{formatNumber(item.amount)}}</span>
                            </div>
                            <div class="item">
                                <span>{{item.amount > 0 ? $t('assets.income') : $t('assets.expense')}}</span>
                            </div>
                            <div class="item coin">
                                <img :src="item.currency.icon" alt="">
                                <span>{{item.currency.symbol}}</span>
                            </div>
                        </div>
                    </div>
                    <div class="btm">
                        <div class="pagination-container">
                            <span class="total-text">{{ paginationText }}</span>
                            <a-pagination 
                                @change="paginate" 
                                :total="total" 
                                :page-size="15" 
                                :show-total="false"
                                show-jumper
                            />
                        </div>
                    </div>
                </div>
            </a-tab-pane>
            <a-tab-pane :title="$t('assets.options_account')" key="4">
                <div class="select-group">
                    <div class="select-label">
                        <p>{{ $t('assets.time') }}</p>
                        <a-range-picker
                            :render-to-body="false"
                            popup-container="body"
                            :defaultValue="timeValue"
                            v-model="timeValue"
                            class="time-button"
                            :allow-clear="false"
                            :placeholder="[$t('common.start_date'), $t('common.end_date')]"
                            @change="onChange"
                            @select="onSelect"
                        />
                    </div>
                    <div class="select-label">
                        <p>{{ $t('assets.flow_type') }}</p>
                        <a-dropdown @select="handleSelect">
                            <a-button class="label-button">
                                {{ selectedType }}
                                <icon-caret-down/>
                            </a-button>
                            <template #content>
                                <a-doption v-for="(item,index) in genre" :key="index" :value="item">{{ $t(item) }}</a-doption>
                            </template>
                        </a-dropdown>
                    </div>
                    <div class="select-label">
                        <p>{{ $t('assets.coin') }}</p>
                        <a-dropdown @select="handleSelect">
                            <a-button class="label-button">
                                {{ selectedCurrency }}
                                <icon-caret-down/>
                            </a-button>
                            <template #content>
                                <a-doption v-for="(item,index) in coinList" :key="index" :value="item">{{ item === 'assets.all_coins' ? $t(item) : item }}</a-doption>
                            </template>
                        </a-dropdown>
                    </div>
                    <div class="select-label">
                        <p style="visibility: hidden;">&nbsp;</p>
                        <a-button class="label-button" @click="reset">
                            {{ $t('assets.reset') }}
                        </a-button>
                    </div>
                </div>

                <div class="list" type="xh">
                    <div class="top">
                        <div class="cell">
                            <div class="item">
                                <span>{{ $t('assets.time') }}</span>
                            </div>
                            <div class="item">
                                <span>{{ $t('assets.type') }}</span>
                            </div>
                            <div class="item">
                                <span>{{ $t('assets.amount') }}</span>
                            </div>
                            <div class="item">
                                <span>{{ $t('common.status') }}</span>
                            </div>
                            <div class="item">
                                <span>{{ $t('assets.coin') }}</span>
                            </div>
                        </div>
                        <div class="cell" v-for="(item,index) in logList" :key="'f'+item.id">
                            <div class="item">
                                <span>{{item.created_at}}</span>
                            </div>
                            <div class="item">
                                <span>{{types[item.type]}}</span>
                            </div>
                            <div class="item">
                                <span>{{formatNumber(item.amount)}}</span>
                            </div>
                            <div class="item">
                                <span>{{item.amount > 0 ? $t('assets.income') : $t('assets.expense')}}</span>
                            </div>
                            <div class="item coin">
                                <img :src="item.currency.icon" alt="">
                                <span>{{item.currency.symbol}}</span>
                            </div>
                        </div>
                    </div>
                    <div class="btm">
                        <div class="pagination-container">
                            <span class="total-text">{{ paginationText }}</span>
                            <a-pagination 
                                @change="paginate" 
                                :total="total" 
                                :page-size="15" 
                                :show-total="false"
                                show-jumper
                            />
                        </div>
                    </div>
                </div>
            </a-tab-pane>
            <a-tab-pane :title="$t('assets.finance_account')" key="5">
                <div class="select-group">
                    <div class="select-label">
                        <p>{{ $t('assets.time') }}</p>
                        <a-range-picker
                            :render-to-body="false"
                            popup-container="body"
                            :defaultValue="timeValue"
                            v-model="timeValue"
                            class="time-button"
                            :allow-clear="false"
                            :placeholder="[$t('common.start_date'), $t('common.end_date')]"
                            @change="onChange"
                            @select="onSelect"
                        />
                    </div>
                    <div class="select-label">
                        <p>{{ $t('assets.flow_type') }}</p>
                        <a-dropdown @select="handleSelect">
                            <a-button class="label-button">
                                {{ selectedType }}
                                <icon-caret-down/>
                            </a-button>
                            <template #content>
                                <a-doption v-for="(item,index) in genre" :key="index" :value="item">{{ $t(item) }}</a-doption>
                            </template>
                        </a-dropdown>
                    </div>
                    <div class="select-label">
                        <p>{{ $t('assets.coin') }}</p>
                        <a-dropdown @select="handleSelect">
                            <a-button class="label-button">
                                {{ selectedCurrency }}
                                <icon-caret-down/>
                            </a-button>
                            <template #content>
                                <a-doption v-for="(item,index) in coinList" :key="index" :value="item">{{ item === 'assets.all_coins' ? $t(item) : item }}</a-doption>
                            </template>
                        </a-dropdown>
                    </div>
                    <div class="select-label">
                        <p style="visibility: hidden;">&nbsp;</p>
                        <a-button class="label-button" @click="reset">
                            {{ $t('assets.reset') }}
                        </a-button>
                    </div>
                </div>

                <div class="list" type="xh">
                    <div class="top">
                        <div class="cell">
                            <div class="item">
                                <span>{{ $t('assets.time') }}</span>
                            </div>
                            <div class="item">
                                <span>{{ $t('assets.coin') }}</span>
                            </div>
                            <div class="item">
                                <span>{{ $t('assets.type') }}</span>
                            </div>
                            <div class="item">
                                <span>{{ $t('assets.quantity') }}</span>
                            </div>
                            <div class="item">
                                <span>{{ $t('common.status') }}</span>
                            </div>
                        </div>
                        <div class="cell" v-for="(item,index) in logList" :key="'i'+item.id">
                            <div class="item">
                                <span>{{item.created_at}}</span>
                            </div>
                            <div class="item coin">
                                <img :src="item.currency.icon" alt="">
                                <span>{{item.currency.symbol}}</span>
                            </div>
                            <div class="item">
                                <span>{{types[item.type]}}</span>
                            </div>
                            <div class="item">
                                <span>{{formatNumber(item.amount)}}</span>
                            </div>
                            <div class="item">
                                <span>{{ $t('assets.completed') }}</span>
                            </div>
                        </div>
                    </div>
                    <div class="btm">
                        <div class="pagination-container">
                            <span class="total-text">{{ paginationText }}</span>
                            <a-pagination 
                                :total="total" 
                                :page-size="15" 
                                @change="paginate" 
                                :show-total="false"
                                show-jumper
                            />
                        </div>
                    </div>
                </div>
            </a-tab-pane>
        </a-tabs>
        <a-modal :visible="modalShow"
                 :closable="false"
                 :hide-title="false"
                 :footer="false"
                 width="450px">
            <template #title>
                <div class="model-title">
                    <span>{{ $t('assets.fund_details') }}</span>
                    <icon-close @click="modalShow = false" />
                </div>
            </template>
            <div class="model-content">
                <div class="coin">
                    <img src="@/assets/images/coin/usdt.png" alt="">
                    <span>USDT</span>
                </div>
                <div class="cell">
                                                    <span>{{ $t('assets.deposit_time') }}</span>
                    <span>2023-09-14 14:15:01</span>
                </div>
                <div class="cell">
                                                    <span>{{ $t('assets.deposit_amount') }}</span>
                    <span>{{formatNumber(21.059222)}}</span>
                </div>
                <div class="cell">
                    <span>{{ $t('assets.confirmations') }}</span>
                    <span>6/6</span>
                </div>
                <div class="cell">
                    <span>{{ $t('common.status') }}</span>
                                                    <span>{{ $t('assets.deposit_success') }}</span>
                </div>
                <div class="cell">
                                                    <span>{{ $t('assets.wallet_processing_time') }}</span>
                    <span>2023-09-14 14:50:01</span>
                </div>
                <div class="column">
                                                    <span>{{ $t('assets.deposit_address') }}</span>
                    <span>TJTE6HJZtYVGYPaAGQhqAFDBRSpH54r5Pj</span>
                </div>
                <div class="column">
                    <span>{{ $t('assets.blockchain_tx_id') }}</span>
                    <span>d6ca082cca9dfcccffd864908504c5f0b305037bfb89daf7efc853c81e82c04a</span>
                </div>
            </div>
        </a-modal>
    </div>
    </a-config-provider>
</template>

<style lang="scss" scoped>
@import "capitalFlow";

.pagination-container {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-top: 20px;
}

.total-text {
    color: var(--color-text-2);
    font-size: 14px;
}
</style>
<script>
import service from './service';

// 扩展service对象，添加ArcoDesign locale配置
const extendedService = {
    ...service,
    computed: {
        ...service.computed,
        // ArcoDesign组件的locale配置
        arcoLocale() {
            const currentLang = this.$i18n?.locale || 'en-US';
            if (currentLang === 'en-US') {
                return {
                    locale: 'en-US',
                    datePicker: {
                        view: {
                            month: 'Month',
                            year: 'Year',
                            week: 'Week',
                            day: 'Day'
                        },
                        month: {
                            long: {
                                January: 'January',
                                February: 'February',
                                March: 'March',
                                April: 'April',
                                May: 'May',
                                June: 'June',
                                July: 'July',
                                August: 'August',
                                September: 'September',
                                October: 'October',
                                November: 'November',
                                December: 'December'
                            },
                            short: {
                                January: 'Jan',
                                February: 'Feb',
                                March: 'Mar',
                                April: 'Apr',
                                May: 'May',
                                June: 'Jun',
                                July: 'Jul',
                                August: 'Aug',
                                September: 'Sep',
                                October: 'Oct',
                                November: 'Nov',
                                December: 'Dec'
                            }
                        },
                        week: {
                            long: {
                                self: 'Week',
                                monday: 'Monday',
                                tuesday: 'Tuesday',
                                wednesday: 'Wednesday',
                                thursday: 'Thursday',
                                friday: 'Friday',
                                saturday: 'Saturday',
                                sunday: 'Sunday'
                            },
                            short: {
                                self: 'Week',
                                monday: 'Mon',
                                tuesday: 'Tue',
                                wednesday: 'Wed',
                                thursday: 'Thu',
                                friday: 'Fri',
                                saturday: 'Sat',
                                sunday: 'Sun'
                            }
                        },
                        placeholder: {
                            date: 'Please select date',
                            week: 'Please select week',
                            month: 'Please select month',
                            year: 'Please select year',
                            quarter: 'Please select quarter',
                            time: 'Please select time'
                        },
                        rangePlaceholder: {
                            date: ['Start date', 'End date'],
                            week: ['Start week', 'End week'],
                            month: ['Start month', 'End month'],
                            year: ['Start year', 'End year'],
                            quarter: ['Start quarter', 'End quarter'],
                            time: ['Start time', 'End time']
                        },
                        selectTime: 'Select time',
                        selectDate: 'Select date',
                        today: 'Today',
                        now: 'Now',
                        ok: 'OK'
                    },
                    pagination: {
                        total: 'Total {total} items',
                        goto: 'Go to',
                        page: 'Page',
                        prev: 'Previous',
                        next: 'Next'
                    }
                };
            }
            return {
                locale: 'zh-CN',
                datePicker: {
                    view: {
                        month: '月',
                        year: '年',
                        week: '周',
                        day: '日'
                    },
                    month: {
                        long: {
                            January: '一月',
                            February: '二月',
                            March: '三月',
                            April: '四月',
                            May: '五月',
                            June: '六月',
                            July: '七月',
                            August: '八月',
                            September: '九月',
                            October: '十月',
                            November: '十一月',
                            December: '十二月'
                        },
                        short: {
                            January: '1月',
                            February: '2月',
                            March: '3月',
                            April: '4月',
                            May: '5月',
                            June: '6月',
                            July: '7月',
                            August: '8月',
                            September: '9月',
                            October: '10月',
                            November: '11月',
                            December: '12月'
                        }
                    },
                    week: {
                        long: {
                            self: '周',
                            monday: '星期一',
                            tuesday: '星期二',
                            wednesday: '星期三',
                            thursday: '星期四',
                            friday: '星期五',
                            saturday: '星期六',
                            sunday: '星期日'
                        },
                        short: {
                            self: '周',
                            monday: '一',
                            tuesday: '二',
                            wednesday: '三',
                            thursday: '四',
                            friday: '五',
                            saturday: '六',
                            sunday: '日'
                        }
                    },
                    placeholder: {
                        date: '请选择日期',
                        week: '请选择周',
                        month: '请选择月份',
                        year: '请选择年份',
                        quarter: '请选择季度',
                        time: '请选择时间'
                    },
                    rangePlaceholder: {
                        date: ['开始日期', '结束日期'],
                        week: ['开始周', '结束周'],
                        month: ['开始月份', '结束月份'],
                        year: ['开始年份', '结束年份'],
                        quarter: ['开始季度', '结束季度'],
                        time: ['开始时间', '结束时间']
                    },
                    selectTime: '选择时间',
                    selectDate: '选择日期',
                    today: '今天',
                    now: '此刻',
                    ok: '确定'
                },
                pagination: {
                    total: '共 {total} 条',
                    goto: '前往',
                    page: '页'
                }
            };
        },
        
        // 自定义分页显示文本
        paginationText() {
            const currentLang = this.$i18n?.locale || 'en-US';
            if (currentLang === 'en-US') {
                return `Total ${this.total} items`;
            }
            return `共 ${this.total} 条`;
        }
    }
};

export default extendedService;
</script>